var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 682.66669 682.66669",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", {
    id: "defs1564",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1574",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path1572",
    fill: "#000000",
    "data-original": "#000000",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1566",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1568",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1570",
    clipPath: "url(#clipPath1574)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1576",
    transform: "translate(317.1094,448.7998)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h -205.709 c -25.57,0 -50.088,-10.156 -68.163,-28.234 -18.083,-18.079 -28.237,-42.599 -28.237,-68.165 v -241 c 0,-25.568 10.154,-50.087 28.237,-68.166 18.075,-18.079 42.593,-28.235 68.163,-28.235 h 241 c 25.569,0 50.087,10.156 68.162,28.235 18.084,18.078 28.237,42.598 28.237,68.166 v 205.712",
    style: {
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1578",
    fill: "none",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: ""
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1580",
    transform: "translate(400.5996,497)",
    strokeWidth: 10,
    style: {
      strokeWidth: 10
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 53.205,0 96.4,-43.195 96.4,-96.4 0,-53.204 -43.195,-96.4 -96.4,-96.4 -53.204,0 -96.399,43.196 -96.399,96.4 C -96.399,-43.195 -53.204,0 0,0 Z",
    style: {
      strokeWidth: 10,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1582",
    fill: "none",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: ""
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.bee13030a4f45f81a9b16a249e77896b.svg";
export { ForwardRef as ReactComponent };